import CTAButton from "./CTAButton";

export default function StickyBar({ price, formatRupiah, onCheckout, canCheckout, visible }) {
  if (!visible) return null;

  return (
    <div className="fixed bottom-0 inset-x-0 z-50 lg:hidden">
      <div className="mx-3 mb-3 rounded-2xl bg-white shadow-luxury border border-border p-3 flex items-center justify-between gap-3">
        <div>
          <div className="text-[10px] uppercase tracking-widest text-muted-foreground">Promo</div>
          <div className="font-display text-lg font-extrabold text-primary leading-none">
            {price ? formatRupiah(price) : "Harga Promo"}
          </div>
        </div>
        <CTAButton size="md" pulse onClick={onCheckout} disabled={!canCheckout}>
          🛒 Pesan Sekarang
        </CTAButton>
      </div>
    </div>
  );
}
